module.exports = __webpack_public_path__ + "static/sunnytech-08305440295754c1f813917edbb99e14.png";